<template lang="pug">
    layout.contentTransparent(fluid)
        template

            // Title
            title-component(
                type="h2"
                slot="title"
                :title="$t('feedback.title')"
            )

        template
            v-layout(row wrap justify-space-between)
                v-flex(xs12)
                    separator-component

                    v-data-table.c-table(
                        v-if="isMobile"
                        :headers-length="7"
                        :items="items"
                        :pagination.sync="pagination"
                        :total-items="total"
                        :rowsPerPageItems="[10]"
                    )
                        template(
                            v-slot:items="props"
                        )
                            tr(@click="props.expanded = !props.expanded")
                                list-mobile(
                                    :item="props.item"
                                    :expanded="props.expanded"
                                    @removed="resetPagination"
                                )

                        template(slot="expand" slot-scope="props")
                            tr
                                td(colspan="6")
                                    expand-card(:item="props.item")

                        template(v-slot:pageText="props")

                    // Users list (Desktop)
                    v-data-table.c-table.visibleHeader(
                        v-if="!isMobile"
                        :headers="headers"
                        :items="items"
                        :pagination.sync="pagination"
                        :total-items="total"
                        :rowsPerPageItems="[10]"
                    )

                        template(slot="items" slot-scope="props")
                            list-item(:item="props.item" @removed="resetPagination")

                        template(v-slot:pageText="props")
</template>

<script>
    import Layout from '../../Layout/Layout';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import users from '~api/users';
    import ListItem from './ListItem';
    import ListMobile from './ListItemMobile';
    import ExpandCard from './ExpandCard';

    export default {
        components: {
            Layout,
            ListItem,
            ListMobile,
            ExpandCard,
            SeparatorComponent: Separator,
            TitleComponent: Title
        },
        data() {
            return {
                headers: this.$t('feedback.tableHeaders'),
                items: [],
                total: 0,
                rowsPerPage: [10],
                pagination: {
                    descending: true
                },
                params: {
                    page: 1,
                    comment: true,
                    sortBy: 'commentedAt',
                    orderBy: 'desc'
                },
                routeInitialized: false
            };
        },
        computed: {
            /**
             * Check screen resolution
             */
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            }
        },

        watch: {
            /**
             * Watch pagination and update managers data on change
             */
            pagination: {
                async handler(paginationData) {
                    if (!this.routeInitialized) {
                        return;
                    }

                    // Collect params.
                    this.params.page = paginationData.page;

                    const resp = await users.list(this.params);

                    const { data } = resp;

                    this.items = data.items;
                    this.total =
                        data.meta && data.meta.total ? data.meta.total : 0;
                },
                deep: true
            }
        },

        // Retrieve Users.
        async beforeRouteEnter(to, from, next) {
            const startParams = {
                page: 1,
                comment: true,
                sortBy: 'commentedAt',
                orderBy: 'desc'
            };

            // Fetch data from API.
            const resp = await users.list(startParams);

            const { data } = resp;

            next(vm => {
                let paginationBlock = document.querySelector(
                    '.v-datatable__actions__range-controls'
                );

                vm.items = data.items;
                vm.total = data.meta && data.meta.total ? data.meta.total : 0;

                vm.pagination = {
                    page: data.meta && data.meta.page ? data.meta.page : 0,
                    rowsPerPage:
                        data.meta && data.meta.limit ? data.meta.limit : 0
                };

                if (paginationBlock) {
                    if (vm.total <= vm.pagination.rowsPerPage) {
                        paginationBlock.style.display = 'none';
                    } else {
                        paginationBlock.style.display = '';
                    }
                }

                vm.$nextTick(() => {
                    vm.routeInitialized = true;
                });
            });
        },
        methods: {
            /**
             * Reset pagination.
             */
            resetPagination() {
                this.pagination = { ...this.pagination };
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_variables.styl";
</style>
